import React from 'react';
import { Link } from 'react-router-dom';
import whiteLogo from '../../../../assets/images/Logos/swimbooker_logo_texticon_white.svg';
import darkLogo from '../../../../assets/images/Logos/swimbooker_logo_texticon_blueblack.svg';

function SiteLogoLink({ variant = 'light', onClick }) {
  return (
    <Link to='/' className='sh-logo row-center' onClick={onClick}>
      <img
        src={variant === 'light' ? whiteLogo : darkLogo}
        alt='swimbooker home'
        width={162}
        height={28}
      />
    </Link>
  );
}

export default SiteLogoLink;
